import { render, staticRenderFns } from "./loginTan.vue?vue&type=template&id=04550c1a&scoped=true"
import script from "./loginTan.vue?vue&type=script&lang=js"
export * from "./loginTan.vue?vue&type=script&lang=js"
import style0 from "./loginTan.vue?vue&type=style&index=0&id=04550c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04550c1a",
  null
  
)

export default component.exports